var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-wrapper"},[_c('GmapMap',{staticClass:"google-map",attrs:{"options":{
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: true,
    rotateControl: false,
    fullscreenControl: false,
    disableDefaultUi: true
  },"center":{lat:47.7836029, lng: 35.2431865},"zoom":16}},[_c('GmapMarker',{ref:"myMarker",attrs:{"position":_vm.google && new _vm.google.maps.LatLng(47.7836029, 35.2431865)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }